<template>
  <div>
    <!-- Header -->
    <div class="header py-5 py-lg-7 pt-lg-7">
      <b-container class="container">
        <div v-if="false" class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">Criar uma conta</h1>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div v-if="false" class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
          xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <!-- Table -->
      <b-row class="justify-content-center bg-white pt-5">
        <b-col lg="6" md="6" sm="6">
          <b-card class="bg-transparent text-center" style="-webkit-box-shadow: none;box-shadow: none;"
            v-if="place_public_data">
            <b-card-body>
              <img v-if="place_public_data.place != undefined"
                :src="`${place_public_data.place.xfields.Logotipo.label.filepath}`"
                style="max-width: 250px;height: auto;max-height: 150px;width: auto;">
              <div class="pt-5" v-if="place_public_data.place != undefined"
                v-html="place_public_data.place.xfields.welcome_msg.label">
              </div>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col lg="6" md="6" sm="6">
          <b-card no-body class="bg-secondary border-0">
            <!-- <b-card-header class="bg-transparent pb-5" v-if="false" >
              <div class="text-muted text-center mt-2 mb-4">
                <small>Cadastrar via</small>
              </div>
              <div class="btn-wrapper text-center">
               <a class="btn btn-neutral btn-icon">
                  <span class="btn-inner--icon"
                    ><img src="img/icons/common/facebook.svg"
                  /></span>
                  <span
                    @click.prevent="facebookRegister"
                    class="btn-inner--text"
                    >FaceBook</span
                  >
                </a>
                <a class="btn btn-neutral btn-icon">
                  <span class="btn-inner--icon"
                    ><img src="img/icons/common/google.svg"
                  /></span>
                  <span @click.prevent="googleRegister" class="btn-inner--text"
                    >Google</span
                  >
                </a>
              </div>
            </b-card-header>  -->
            <b-card-body class="px-lg-5 py-lg-5">
              <div class="text-muted mb-4">
                <h3>Novo usuário
                </h3>
                <small>informe os dados do novo cliente</small>
              </div>
              <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                <b-form role="form" @submit.prevent="handleSubmit(normalRegister)">
                  <!-- <span class="mr-3">Tipo de conta:</span>
                  <select class="form-select mb-3" 
                    aria-label="Default select example" 
                    v-model="form.conta">
                    <option disabled selected>Tipo de conta</option>
                    <option value="fisica">Física</option>
                    <option value="juridica">Jurídica</option>
                  </select> -->
                  <validation-observer ref="observerSocialLogin" rules="required">
                    <base-input alternative class="mb-3" prepend-icon="ni ni-hat-3" placeholder="Nome/Razão Social"
                      name="Name" :rules="{ required: true }" v-model="form.name">
                    </base-input>
                    <base-input v-mask="form.cpf_cnpj.length <= 14 ? ['###.###.###-##'] : ['##.###.###/####-##']"
                      alternative class="mb-3" :masked="true" prepend-icon="ni ni-lock-circle-open" placeholder="CPF/CNPJ"
                      type="text" name="CPF" v-model="form.cpf_cnpj">
                    </base-input>
                  </validation-observer>

                  <base-input alternative class="mb-3" prepend-icon="ni ni-email-83" placeholder="Email" name="Email"
                    :rules="{ required: true, email: true }" v-model="form.email">
                  </base-input>

                  <base-input alternative class="mb-3" prepend-icon="ni ni-lock-circle-open" placeholder="Senha"
                    type="password" name="Senha" :rules="{ required: true, min: 6 }" v-model="form.password">
                  </base-input>

                  <base-input alternative class="mb-3" prepend-icon="ni ni-lock-circle-open"
                    placeholder="Confirme a Senha" type="password" name="confirmarSenha"
                    :rules="{ required: true, min: 6 }" v-model="form.confirmaPassword">
                  </base-input>
                  <div class="text-center">
                    <b-button type="submit" variant="primary" class="mt-4">Cadastrar</b-button>

                    <!-- <router-link v-if="false" :to="{ path: '/login' }">
                      <base-button class="btn btn-md btn-default mt-4" type="button">Entrar</base-button>
                    </router-link> -->
                  </div>
                  <small>
                    <div class="text-right mt-4">
                      já é cadastrado?
                      <router-link :to="{ path: `/login${form.pid != undefined ? '?pid=' + form.pid : ''}` }">
                        fazer login
                      </router-link>
                    </div>
                  </small>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import axios from 'axios'

import swal from "sweetalert2";
import bocapioNodeService from "../../services/nodejs/index"
import bocapioCakeService from "../../services/cakephp/index"
import TokenKey from "../../store/utils/tokenNode"
import { initFbsdk } from "@/plugins/facebookLogin.js"
import { mapActions } from "vuex"
import { VueMaskDirective } from 'v-mask'
import { nodeApi } from "../../services/config"
export default {
  name: "userRegister",
  directives: { mask: VueMaskDirective },
  data() {
    return {
      form: {
        name: "",
        email: "",
        telefone: "",
        cpf_cnpj: "",
        password: "",
        confirmaPassword: "",
        pid: ""
      },
      user: {},
      inputTest: "",
      place_public_data: false
    };
  },
  methods: {
    ...mapActions(["AUTH_LOGIN_REQUEST", "AUTH_LOGOUT"]),
    onChange(event) {
      console.log("value", event.target.value);
    },
    normalRegister() {
      if (this.form.password === this.form.confirmaPassword) {
        this.user = {
          username: this.form.email,
          password: this.form.password
        }
        bocapioNodeService.register(this.form).then((response) => {
          localStorage.setItem(TokenKey, this.user)
          sessionStorage.setItem("username", this.form.email)
          sessionStorage.setItem("password", this.form.password)
          this.$router.push({ path: `/login${this.form.pid != undefined ? '?pid=' + this.form.pid : ''}` })
        })
          .catch((error) => {
            swal.fire({
              title: error.data.status == "errro" ? "Erro" : "Atenção",
              text: error.data.message,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-warning",
              // icon: "warning",
            })
          })
      } else {
        swal.fire({
          title: `Dados incorretos`,
          text: "Confirmar senha informado não corresponde com a senha...",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-default",
          icon: "error"
        })

      }
      console.log('0009s')

    },

    facebookRegister() {
      window.FB.login(response => {
        console.log("fb response", response);
      }, this.params);
    },

    async googleRegister() {
      console.log("Entrou no Método de cadastro");
      const isValid = await this.$refs.observerSocialLogin;
      console.log("isValid", isValid);
      if (isValid) {
        this.$gAuth
          .signIn()
          .then(GoogleUser => {
            // on success do something
            console.log("GoogleUser", GoogleUser);
            var userInfo = {
              loginType: "google",
              google: GoogleUser
            };
            this.AUTH_LOGIN_REQUEST(userInfo)
            router.push("/home")
            //this.$router.push({ path: '/login'})
          })
          .catch(error => {
            console.log("error", error);
          });
      }
    }
  },
  created() {
    this.$parent.$parent.$on('place_public_data_loaded', () => {
      this.place_public_data = this.$parent.$parent.place_public_data
    });
  },
  mounted() {
  }
};
</script>
<style></style>
